export const palletsTypes = {
  abbr: {
    CUSTOM_PALLET: 'Sp',
    US_PALLET: 'Us',
    MIXED_PALLET: 'Mx',
    EU_PALLET: 'Eu',
  },
  full: {
    CUSTOM_PALLET: 'Custom',
    US_PALLET: 'American',
    MIXED_PALLET: 'Mixed',
    EU_PALLET: 'European',
  },
};
